import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Liberación de Bloqueo del Dinero** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a identificar y liberar bloqueos financieros, creencias limitantes y patrones que frenan su abundancia, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Tu relación actual con el dinero (¿cómo es tu energía real con el dinero hoy?):** ${cardLabel(
        cards[0]
    )}, **Creencia limitante principal (¿cuál es la creencia que más te está frenando?):** ${cardLabel(
        cards[1]
    )}, **Origen del bloqueo (¿de dónde viene esa creencia o patrón?):** ${cardLabel(
        cards[2]
    )}, **Cómo se manifiesta en tu vida (¿de qué forma concreta te está afectando?):** ${cardLabel(
        cards[3]
    )}, **Beneficio secundario del bloqueo (¿qué te "da" mantener este bloqueo, aunque duela?):** ${cardLabel(
        cards[4]
    )}, **Miedo o resistencia que hay detrás (¿qué miedo hay debajo de este bloqueo?):** ${cardLabel(
        cards[5]
    )}, **Qué tenés que soltar (¿qué creencia o patrón necesitás liberar?):** ${cardLabel(
        cards[6]
    )}, **Nueva creencia o energía a incorporar (¿qué creencia o energía necesitás integrar?):** ${cardLabel(
        cards[7]
    )}, **Acción concreta recomendada (¿qué paso podés dar para empezar a mover esto?):** ${cardLabel(
        cards[8]
    )} y **Energía de abundancia que viene (¿qué energía de dinero se está abriendo si hacés este trabajo?):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente sobre el bloqueo del dinero: conecta la relación actual con el dinero, la creencia limitante, su origen, cómo se manifiesta, el beneficio secundario del bloqueo y el camino de liberación. Detecta patrones, miedos ocultos y resistencias. Proporciona consejos prácticos y concretos para transformar la relación con el dinero y abrirse a la abundancia. Mantén un tono profesional, empático, motivador y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
